import { DataService } from './dataService'

const JobService = {
	addJobservice: async (data) => {
		return DataService.post('/admin/add_job', data)
		// return DataService.post('/admin/add_update_job', data)
	},
	addJobdocument: async (data) => {
		return DataService.post('/admin/add_job_document', data)
	},
	getJobapi: async (data) => {
		return DataService.get('/admin/get_job', data,true)
	},
	getClosedJobapi: async (data) => {
		return DataService.get('/admin/get_closed_job', data)
	},
	getJobDetails: async (data) => {
		return DataService.get('/admin/get_job_details', data)
	},
	updateJobservice: async (data) => {
		return DataService.post('/admin/update_job', data)
	},
	approveExportDocument: async (data) => {
		return DataService.post('/admin/approve_export_document', data)
	},
	saveExportDocument: async (data) => {
		return DataService.post('/admin/save_export_document', data)
	},
	updatePaymentInfo: async (data) => {
		return DataService.post('/admin/update_payment_info', data)
	},
	getPayInvoiceJob: async (data) => {
		return DataService.get('/admin/getPayInvoiceJob', data)
	},
	getPayInvoiceByJob: async (data) => {
		return DataService.get('/admin/getPayInvoiceByJob', data)
	},
	getPayRetailerJobs: async (data) => {
		return DataService.get('/admin/getPayRetailerJobs', data)
	},
	getRetailers: async (data) => {
		return DataService.get('/admin/search_retailer', data)
	},
	updateRetailerPayStatus: async (data) => {
		return DataService.post('/admin/updateRetailerPayStatus', data)
	},
	getPayCustomerJob: async (data) => {
		return DataService.get('/admin/getPayCustomerJob', data)
	},
	assignPaymentToJob: async (data) => {
		return DataService.post('/admin/assignPaymentToJob', data)
	},
	getUserAdvancePayments: async (data) => {
		return DataService.get('/admin/qbook/getUserAdvance', data)
	},
	setJobOpenStatus: async (data) => {
		return DataService.post('/admin/update_job_open_status', data)
	},
	getAdvanceInvoiceJob:async (data) => {
		return DataService.get('/admin/getAdvanceInvoiceJob', data)
	},
	deleteJob:async (data) => {
		return DataService.post('/soft_delete/job', data)
	},
	deleteJobDocument:async (data) => {
		return DataService.post('/admin/update_document_job', data)
	},
	closeFinancialStatus:async (data) => {
		return DataService.post('/admin/set_job_financial_open', data)
	},
	getoutstandingJobs: async (data) => {
		return DataService.get('/admin/outstanding_jobs', data,true)
	},


}

export default JobService